import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { getId, useCurrentUser, usePermissions } from "../user/User"

const Sidebar = ({ appName }) => {
  const [ sidebar, setSidebar ] = useState("")
  const { id, email, name } = useCurrentUser()
  const { permissions } = usePermissions(getId())
  const [settingsDisplay, setSettingsDisplay] = useState("none")

  useEffect(() => {
    setSidebar(<>
      { permissions.client !== undefined && permissions.client ?
        <>
          <li className="nav-item">
            <Link to="/client/board" className="nav-link">
              <i className="nav-icon fa-solid fa-chart-kanban"></i>
              <p>Client board</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/client" className="nav-link">
              <i className="nav-icon fa-solid fa-person"></i>
              <p>Clients</p>
            </Link>
          </li>
        </>
        : ""
      }
      { (permissions.sector !== undefined && permissions.sector) || (permissions.tag !== undefined && permissions.tag) || (permissions.user !== undefined && permissions.user) ||
      (permissions.status !== undefined && permissions.status) ?
        <>
          <li className="nav-item">
            <a href="#" onClick={(e) => {
              e.preventDefault()
              setSettingsDisplay(prev => {
                let newValue = ""
                if(prev == "none") {
                  newValue = "block"
                } else {
                  newValue = "none"
                }
                let link = document.querySelector("#settingsItem")
                link.style.display = newValue
                return newValue
              })
            }} className="nav-link">
              <i className="nav-icon fa-solid fa-gear"></i>
              <p>
                Settings
                <i className="nav-arrow fa-solid fa-chevron-right"></i>
              </p>
            </a>
            <ul id="settingsItem" className="nav nav-treeview" style={{boxSizing: "border-box", display: settingsDisplay}}>
              { permissions.user !== undefined && permissions.user ?
                <li className="nav-item">
                  <Link to="/user" className="nav-link">
                    <i className="nav-icon fa-solid fa-users"></i>
                    <p>Users</p>
                  </Link>
                </li>
                : ""
              }
              { permissions.sector !== undefined && permissions.sector ?
                <li className="nav-item">
                  <Link to="/sector" className="nav-link">
                    <i className="nav-icon fa-solid fa-buildings"></i>
                    <p>Sectors</p>
                  </Link>
                </li>
                : ""
              }
              { permissions.tag !== undefined && permissions.tag ?
                <li className="nav-item">
                  <Link to="/tag" className="nav-link">
                    <i className="nav-icon fa-solid fa-tags"></i>
                    <p>Tags</p>
                  </Link>
                </li>
                : ""
              }
              { permissions.status !== undefined && permissions.status ?
                <li className="nav-item">
                  <Link to="/status" className="nav-link">
                    <i className="nav-icon fa-solid fa-bars-progress"></i>
                    <p>Status</p>
                  </Link>
                </li>
                : ""
              }
            </ul>
          </li>
        </>
        : ""
      }
    </>)
  }, [permissions, id, name, email])

  return (
    <aside className="app-sidebar bg-body-secondary shadow" data-bs-theme="dark">
      <div className="sidebar-brand">
        <Link to="/" className="brand-link">
          <img src={process.env.REACT_APP_API_URL + "/images/logo_small_white.png"} className="brand-image shadow" />
          <span className="brand-text fw-light">{ appName }</span>
        </Link>
      </div>

      <div className="sidebar-wrapper" data-overlayscrollbars="host">
        <div className="os-size-observer">
          <div className="os-size-observer-listener">
          </div>
        </div>

        <div data-overlayscrollbars-viewport="scrollbarHidden overflowXHidden overflowYScroll" tabIndex="-1" style={{
          marginRight: "-16px",
          marginBottom: "-16px",
          marginLeft: "0px",
          top: "-8px",
          right: "auto",
          left: "-8px",
          width: "calc(100% + 16px)",
          padding: "8px",
        }}>
          <nav className="mt-2">
            <ul className="nav sidebar-menu flex-column" role="menu" data-accordion="false">
              {sidebar}
            </ul>
          </nav>
        </div>

        <div className="os-scrollbar os-scrollbar-horizontal os-theme-light os-scrollbar-auto-hide os-scrollbar-handle-interactive os-scrollbar-track-interactive os-scrollbar-cornerless os-scrollbar-unusable os-scrollbar-auto-hide-hidden" style={{
          '--os-scroll-percent': '0',
          '--os-viewport-percent': '1',
          '--os-scroll-direction': '0'
        }}>
          <div className="os-scrollbar-track">
            <div className="os-scrollbar-handle">
            </div>
          </div>
        </div>
        <div className="os-scrollbar os-scrollbar-vertical os-theme-light os-scrollbar-auto-hide os-scrollbar-handle-interactive os-scrollbar-track-interactive os-scrollbar-visible os-scrollbar-cornerless os-scrollbar-auto-hide-hidden" style={{
          '--os-scroll-percent': '0',
          '--os-viewport-percent': '0',
          '--os-scroll-direction': '0'
        }}>
          <div className="os-scrollbar-track">
            <div className="os-scrollbar-handle">
            </div>
          </div>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar